
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState } from "react";
import Head from "next/head";
import HeaderSearch from "../../component/common/HeaderSearch";
import { initializeApollo } from "../../apollo-client";
import { gql } from "@apollo/client";
import { LISTING_FRAGMENT } from "../../action/listingRecommendation";
import ZoomModal from "../../component/ListingSlider/ZoomModal";
import Image from "next/image";
import ListingItem from "../../component/common/ListingItem";
import { TRACK_LISTING_VIEW } from "../../utils/trackEvent";
import { useStateContext } from "../../context";
import dynamic from "next/dynamic";
import Footer from "../../component/common/Footer";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";
const ListingAction = dynamic(() => import("../../component/ListingAction"), {
    ssr: false
});
const AgentDetail = (props) => {
    const { data } = props;
    const { t } = useTranslation("packages");
    const [state, setState] = useStateContext();
    const clickCount = state.countView;
    const listing = data?.user_listings;
    const agentDetail = data?.user;
    const [zoomModalOpen, setZoomModalOpen] = useState(false);
    const handleOnListingClick = (listingDetail) => {
        TRACK_LISTING_VIEW(`${listingDetail.id}`, {
            from: "listing-view-by-agent",
            area: listingDetail.area.area_name,
            category: listingDetail.category,
            district: listingDetail.district.district_name,
            listingFor: listingDetail.listingFor,
            state: listingDetail.state.state_name
        });
    };
    return (<div className="">
      <Head>
        <title>{`${agentDetail?.first_name} ${agentDetail?.last_name !== null ? agentDetail?.last_name : ""} | rumahdewi.com`}</title>
      </Head>
      <div className="position-relative">
        <Image src="/assets/agent-background.png" alt="Agent Background" layout="fill" objectFit="cover" className="position-absolute w-100 h-100" style={{ top: 0, left: 0 }} placeholder="blur" blurDataURL="/assets/agent-background.png"/>

        <HeaderSearch />
        <div className="d-none d-md-block col-12 col-md-5 col-lg-4 sticky-top h-100 container" style={{ zIndex: 2 }}>
          <AgentCard agentDetail={agentDetail} listing={listing}/>
        </div>
        <div className="d-block d-md-none col-12 col-md-5 col-lg-4 position-relative">
          <AgentCard agentDetail={agentDetail} listing={listing}/>
        </div>
      </div>
      <div className="container pt-4">
        <div className="row g-4">
          <div className="col-12">
            <p className="fs-5 mb-0 text-primary" style={{ fontWeight: "600" }}>
              ({listing.total_active}) {t("package_card.active listing")}
            </p>
            <div className="bg-primary" style={{
            width: "10%",
            height: "3px",
            marginTop: "10px",
            marginBottom: "20px"
        }}></div>
            <div className="row ">
              {listing?.active_listings.map((row) => (<div className="col-md-4 mb-4" key={`listing-${row.id}`}>
                  <ListingItem {...row} photoHeight={"240px"} onClick={() => {
                handleOnListingClick(row);
            }} clickCount={clickCount} setClickCount={() => setState({ ...state, countView: clickCount + 1 })}/>
                </div>))}
            </div>
          </div>
        </div>
      </div>

      {zoomModalOpen && (<ZoomModal show={zoomModalOpen} medias={listing?.media} productName={listing?.product_name} setShow={setZoomModalOpen}/>)}
      <Footer />
    </div>);
};
export default AgentDetail;
export function AgentCard(props) {
    const { agentDetail, listingUrl, listing, id } = props;
    return (<div style={{ position: "relative", zIndex: 50 }}>
      <div className="d-flex flex-md-row flex-column gap-3 justify-content-between align-items-center pb-2 pb-md-0">
        <div className="d-flex flex-row gap-3 align-items-center">
          <div className="d-flex flex-row gap-3 align-items-center" style={{ marginTop: "50px", marginBottom: "32px" }}>
            <div className="border-white" style={{
            padding: "2px",
            border: "2px dashed",
            borderRadius: "100%",
            position: "relative",
            width: "6.25em",
            height: "6.25em",
            overflow: "hidden"
        }}>
              {agentDetail?.avatar_file === null ? (<Image src="/assets/no-image.png" layout="fill" objectFit="cover" alt="no-media" placeholder="blur" blurDataURL="/assets/no-image.png"/>) : (<Image src={agentDetail?.avatar_file?.sizes.thumb} layout="fill" objectFit="cover" alt={`${agentDetail?.first_name} ${agentDetail?.last_name}`} placeholder="blur" blurDataURL={agentDetail?.avatar_file?.sizes.thumb}/>)}
            </div>
          </div>

          <div className="d-flex flex-column w-75">
            <Link href={`/agent/${agentDetail?.user?.id}`}>
              <a>
                <p className="mb-0 h5 text-white" style={{ fontWeight: "600", fontSize: "25px" }}>
                  {agentDetail?.first_name} {agentDetail?.last_name}
                </p>
              </a>
            </Link>
            <p className="mb-0 text-white" style={{ fontWeight: "400", fontSize: "18px" }}>
              {agentDetail?.user_level === 2
            ? "Member"
            : agentDetail?.user_level === 3
                ? "Agent"
                : "Pemilik Rumah"}
            </p>
          </div>
        </div>
        <ListingAction type={1} id={id} user={agentDetail} listingUrl={listingUrl} name={listing.product_name}/>
      </div>
    </div>);
}
async function getServerSideProps(params) {
    const { id } = params.query;
    try {
        const client = initializeApollo();
        const { data } = await client.query({
            query: gql `
      query user_data {
        user(id: ${id}) {
        user_id
        user_level
        first_name
        last_name
        phone
        info
        avatar_file {
          sizes {
            thumb
            small
          }
        }
      }
      user_listings (user_id: ${id}, ascending: false) {
        total_active
        total_sold
        active_listings {
            ...LandingListing
        }
      }
    }
      ${LISTING_FRAGMENT}
    `
        });
        return {
            props: {
                data
            }
        };
    }
    catch (error) {
        console.log(error);
        return {
            props: {
                data: null,
                error: true
            }
        };
    }
}

    async function __Next_Translate__getServerSideProps__1967a7f1e18__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/agent/[id]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1967a7f1e18__ as getServerSideProps }
  